import { z } from 'zod';
import { SerializerDecimal } from '../../../../../utils/formatterDecimal';
import ValidationContactFormService from '../../../../../common/services/validation-contact-form/valitation-contact-form.service';
import IValidEgatesIdModel from '../../../interfaces/IValidEgatesIdModel';
import i18n from '../../../../../lib/i18n';

const requiredFieldMessage = i18n.t('RequiredFieldMessage');
const invalidInformation = i18n.t('InvalidInformation');
const incorrectPaymentTermMessage = i18n.t('IncorrectPaymentTermMessage');
const IdEgatesAlreadyExistsMessage = i18n.t('IdEgatesAlreadyExistsMessage');

const defaultMessages = {
    invalid_type_error: invalidInformation,
    required_error: requiredFieldMessage,
};

const addCustomIssue = (
    ctx: z.RefinementCtx,
    path: string,
    message: string,
) => {
    ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: [path],
        message,
    });
};
const requiredString = () => {
    return z.string(defaultMessages).min(1, requiredFieldMessage);
};

const addCustomIssueWithoutPath = (ctx: z.RefinementCtx, message: string) => {
    ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message,
    });
};
const checkIsValidPaymentTerm = (paymentTerm: string, ctx: any) => {
    if (Number(SerializerDecimal(paymentTerm)) < 10) {
        addCustomIssueWithoutPath(ctx, incorrectPaymentTermMessage);
    }
};
export const GeneralValidationSchema = z.object({
    tradeName: requiredString(),
    paymentTerm: requiredString()
        .min(2, incorrectPaymentTermMessage)
        .superRefine((data: string, ctx: any) => {
            checkIsValidPaymentTerm(data, ctx);
        }),
    carriersContact: ValidationContactFormService.contactValidationSchema(),
});

const idEgatesCustomValidation = async (
    data: IValidEgatesIdModel,
    ctx: z.RefinementCtx,
) => {
    if (data.existingCarriers && data.existingCarriers.totalItems > 0) {
        addCustomIssue(ctx, 'id', IdEgatesAlreadyExistsMessage);
    }

    if (data.legacy === true && !data.sulaHubId) {
        addCustomIssue(ctx, 'id', requiredFieldMessage);
    }
};

export const ValidEgatesId = z
    .object({
        sulaHubId: z.string(),
        legacy: z.boolean(),
        existingCarriers: z.any(),
    })
    .partial()
    .superRefine((data: IValidEgatesIdModel, ctx: any) => {
        idEgatesCustomValidation(data, ctx);
    });
